import { styled } from 'stitches.config'

export const HeroContainer = styled('div', {
    width: '100%',
    padding: '32px 8px 24px 8px',
  
    '@bp3': {
      width: '50%',
      padding: '48px 0px 108px 0px',
    },
  })

export const ImageWrapper = styled('div', {
  position: 'relative',
  width: '100%',
  maxWidth: '904px',
  fontSize: 0,
  lineHeight: 0,
})
